module.exports = __webpack_public_path__ + "img/direct-download-grey.44596f18.svg";